import { User as ActionTypes } from '../actionTypes';

const initialState = {
  data: [],
  override: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.CREATE:
      return {
        ...state,
        data: [...state.data, ...payload],
      };
    case ActionTypes.OVERRIDE:
      return {
        ...state,
        data: payload,
        override: true,
      };
    case ActionTypes.REMOVE:
      return {
        ...state,
        data: state.data.reduce((list, item) => {
          const result = payload.find(elem => elem.Username === item.Username);

          if (!result) {
            list.push(item);
          }

          return list;
        }, []),
      };
    case ActionTypes.UPDATE:
      return {
        ...state,
        data: state.data.reduce((list, item) => {
          const result = payload.find(elem => elem.Username === item.Username);

          if (result) {
            list.push({ ...item, ...result.Data });
          } else {
            list.push(item);
          }

          return list;
        }, []),
      };
    default:
      return state;
  }
};
